/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const enableMonitoringIntegrationBodyExpectedVersionExclusiveMin = 0;
export const enableMonitoringIntegrationBodyExpectedVersionMax = 9007199254740991;

export const EnableMonitoringIntegrationBody = zod.object({
  expectedVersion: zod
    .int()
    .gt(enableMonitoringIntegrationBodyExpectedVersionExclusiveMin)
    .max(enableMonitoringIntegrationBodyExpectedVersionMax),
});

export type EnableMonitoringIntegrationBody = zod.input<typeof EnableMonitoringIntegrationBody>;
export type EnableMonitoringIntegrationBodyOutput = zod.output<
  typeof EnableMonitoringIntegrationBody
>;
